import { Key, ReactNode } from 'react';
import { cn } from 'utils/cn';

export interface HistoryTimelineEntry {
    key: Key;
    tone: 'success' | 'error' | 'neutral';
    children: ReactNode;
}

const DOT_CLASS: Record<HistoryTimelineEntry['tone'], string> = {
    success: 'bg-success',
    error: 'bg-error',
    neutral: 'bg-grey-400',
};

export function HistoryTimeline({ entries }: { entries: HistoryTimelineEntry[] }) {
    return (
        <ul className="m-0 list-none p-2">
            {entries.map((entry, index) => (
                <li key={entry.key} className="flex min-h-[70px]">
                    <div className="flex flex-col items-center">
                        <span className={cn('my-1 size-3 shrink-0 rounded-full', DOT_CLASS[entry.tone])} />
                        {index < entries.length - 1 ? <span className="bg-grey-400 w-0.5 grow" /> : null}
                    </div>
                    <div className="flex-1 px-3 py-1">{entry.children}</div>
                </li>
            ))}
        </ul>
    );
}
